import {
  IMockProps,
  ErrorResponseCodeType,
  Mocks,
  MockServiceType,
} from '../../Core';
import { CODE_ERRORS, ENDPOINT_API_PATH } from '../../Apis/GeoLocationApi';
import { GeoLocationTypes } from '../../Types';
import MocksDef from '../../Mocks/GeoLocationMocksDef';

type ParamsType = {
  type: string;
  langague?: string;
  input?: string;
  address?: string;
  placeId?: string;
  product?: string;
};

/** Mocks de Sucesso */
const mocksSuccess: IMockProps[] = [];

/** Mocks de Erro */
let mocksErrors: IMockProps[] = [];

const generateSuccess = (params: ParamsType): IMockProps => {
  let data;
  switch (params.type) {
    case 'autocomplete':
      data = MocksDef.AUTOCOMPLETE_RESPONSE;
      break;
    case 'detail':
      data = MocksDef.DETAIL_RESPONSE;
      break;
    case 'geolocation':
      data = MocksDef.GEOLOCATION_RESPONSE;
      break;
    case 'places':
      data = MocksDef.PLACES_RESPONSE;
      break;
    default:
      data = [];
      break;
  }
  return {
    configRequest: {
      method: 'GET',
      path: ENDPOINT_API_PATH,
      params,
    },
    configResponse: {
      status: 200,
      data,
    },
  };
};

const generateDefaultErrors = (params: ParamsType): IMockProps[] => {
  return CODE_ERRORS.map(
    (error: ErrorResponseCodeType<null>, index: number): IMockProps => {
      return {
        configRequest: {
          method: 'GET',
          path: ENDPOINT_API_PATH,
          params: {
            type: params.type,
            input: `${index}-${params.input}`,
          },
          body: null,
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };
    },
  );
};

mocksSuccess.push(
  generateSuccess({
    type: 'autocomplete',
    input: '30310-110',
  }),
);
mocksSuccess.push(
  generateSuccess({
    type: 'detail',
    placeId: 'ChIJFR-lEyMCz5QRjWFy92Z4498',
  }),
);
mocksSuccess.push(
  generateSuccess({
    type: 'geolocation',
    address: '-22.250250,-49.921820',
  }),
);
mocksSuccess.push(
  generateSuccess({
    type: 'places',
    input: 'Osasco',
    product: 'hotel',
  }),
);

mocksErrors = mocksErrors.concat(
  generateDefaultErrors({
    type: 'autocomplete',
    input: '30310-110',
  }),
);

export const mocksService: MockServiceType<GeoLocationTypes.GeoLocationServiceRequestType>[] =
  mocksSuccess.map((request) => ({
    label: `[Sucesso] - ${JSON.stringify(request.configRequest.params)}`,
    value: request.configRequest.params,
  }));

const allMocks: IMockProps[] = mocksSuccess.concat(mocksErrors);

Mocks.getInstance().addAll(allMocks);
